import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    if (!email) return;
    setSubmitted(true);
  }

  return (
    <section className="py-20 bg-gradient-to-br from-primary via-accent1 to-accent2 relative overflow-hidden">
      <div className="absolute top-20 left-20 w-40 h-40 bg-white/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-20 right-20 w-48 h-48 bg-secondary/30 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="text-6xl mb-6">📧</div>
        <h2 className="text-4xl md:text-5xl font-black text-white mb-6">Join the Fun Club!</h2>
        <p className="text-xl text-white/90 mb-10">Subscribe to get special offers, free giveaways, and exclusive deals! 🎁</p>

        {submitted ? (
          <div className="bg-white/20 backdrop-blur-md rounded-full px-10 py-6 inline-block border-4 border-white/40">
            <span className="text-white font-black text-xl">🎉 You're in! Check your inbox soon.</span>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
              className="flex-1 px-8 py-5 rounded-full text-lg border-4 border-white/30 focus:outline-none focus:border-white bg-white/20 backdrop-blur-md text-white placeholder-white/70"
            />
            <button
              type="submit"
              className="bg-secondary hover:bg-yellow-300 text-textDark font-black text-lg px-10 py-5 rounded-full shadow-2xl transition-all transform hover:-translate-y-1 whitespace-nowrap"
            >
              Subscribe Now!
            </button>
          </form>
        )}

        <p className="text-white/80 text-sm mt-6">🔒 We respect your privacy. Unsubscribe anytime.</p>
      </div>
    </section>
  );
}
